enum BatchExclusionReason {
    NonCertifiedAddress = 'NonCertifiedAddress',
    ExceedsMaximumBalance = 'ExceedsMaximumBalance',
    HasPendingReloadableCard = 'HasPendingReloadableCard',
    DoesNotMeetMinimumLoad = 'DoesNotMeetMinimumLoad',
    CustomerDoesNotHaveDateOfBirth = 'CustomerDoesNotHaveDateOfBirth',
    HasNonActivatedReloadableCard = 'HasNonActivatedReloadableCard',
    CustomerDoesNotHaveSSN = 'CustomerDoesNotHaveSSN',
}

export default BatchExclusionReason;
